import axios from "axios";
import { API } from "./apiConfig";

const authHeader = () => ({ withCredentials: true });

export const getMyAccess = async () => {
  const { data } = await axios.get(`${API}/access/me`, authHeader());
  return data;
};

export const getAccessControlConfig = async () => {
  const { data } = await axios.get(`${API}/admin/access-control`, authHeader());
  return data;
};

export const updatePackageAccessControl = async (packageId, payload) => {
  const { data } = await axios.put(
    `${API}/admin/access-control/${packageId}`,
    payload,
    authHeader()
  );
  return data;
};

export const getFeatureAccess = (access, featureKey) => (
  access?.features?.[featureKey] || { enabled: false, value: {} }
);
